export default __webpack_public_path__ + "compass-circular-variant.png";